<template>
  <div class="shadow-modal">
  <transition name="modal-fade">
    <div class="modal-backdrop" @click="close()">
      <div class="modal u-align--left u-color--grey-dark"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription"
           @click.stop>
          <div v-if="displayCross" @click="close()" class="btn-close-modal">
            <img src="@/assets/img/icons.svg#icon-close" width="20" height="20" aria-label="Close modal">
          </div>
         <div v-else class="donotask-container">
            <a :text="'Ne plus demander'" class="u-bg--orange doNotAsk" @click="$emit('closeAndSaveCookie')">Ne plus demander</a>

            <div @click="close()" class="btn-close u-bg--orange">
              <img src="@/assets/img/icons.svg#icon-close-white" width="20" height="20" aria-label="Close modal">
            </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: ['displayCross', 'study'],
    data: () => {
      return {
        // dontShowAgain: false
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    },
    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.$emit('close');
        }
      })
    }
  };
</script>



<style lang="scss">

  /*add a transition for the opacity to fade slowly by using the applied classes*/
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }

  .modal-backdrop {
    position: fixed;
    z-index: 9998;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .3s ease;

    .modal {
      background: #FFFFFF;
      box-shadow: 0 0 14px 0 rgba(0,0,0,0.2);
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      max-width: rem(600px);
      padding: rem(50px);
      cursor: default;
      min-height: rem(600px);
      max-height: calc(100vh - 100px);
      z-index: 10000;
      position: relative;

      @include mq($until: SM) {
        max-width: rem(352px);
        padding: rem(30px) rem(20px) rem(40px);
        max-height: calc(100vh - 50px);
        min-height: rem(300px);
      }

      .btn-close-modal {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        padding: rem(27px);
        cursor: pointer;
      }

      .iconTitle {
        font-size: rem(22px)!important;
        max-width: rem(490px);

        @include mq($until: SM) {
          font-size: rem(18px);
          max-width: rem(280px);
        }
      }

      .donotask-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .doNotAsk {
          color: white;
          padding: rem(7px) rem(15px);
          border-radius: 15px 0 0 15px;
          font-size: rem(14px);
          cursor: pointer;

          &:hover {
            background-color: color(orange-hover);
          }
        }

        .btn-close {
          height: rem(33px);
          border-radius: 0 15px 15px 0;
          margin-left: rem(2px);
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: rem(30px);
          cursor: pointer;

          &:hover {
            background-color: color(orange-hover);
          }

          img {
            padding: rem(3px);
          }
        }
      }
    }
  }
</style>